import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsViewsCountByTimeTab = _resolveComponent("StatisticsViewsCountByTimeTab")!

  return (_openBlock(), _createBlock(_component_StatisticsViewsCountByTimeTab, {
    filter: _ctx.filter,
    tableStorePaths: _ctx.tableStorePaths,
    periodColumn: _ctx.periodColumn,
    chartStorePaths: _ctx.chartStorePaths
  }, null, 8, ["filter", "tableStorePaths", "periodColumn", "chartStorePaths"]))
}